export class TimeUtils {
	public millisecondsToSeconds (ms: number | string) {
		return Math.floor(Number(ms) / 1000);
	}
}
